import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MarcaEdit from '../../components/Marca/marcaNuevo';
import { sagaSaveMarca, sagaGetMarca } from '../../reducers/marcasReducer/actions';
import { marcasEditSelector } from '../../selectors/marcasSelector';
import { usuarioSelector, instalacionSelector } from '../../selectors/sessionSelector';
import * as Notification from '../../components/Common/notification';

class MarcaEditContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            marca: {
                idMarca: 0,
                nombre: '',
                codigo: '',
            },
            error: null
        };
    }

    componentDidMount() {
        const { match: { params } } = this.props;
        if (params.idMarca && params.idMarca !== '0') {
            this.props.sagaGetMarca(params.idMarca);
        } else {
            this.setState({
                marca: {
                    idMarca: 0,
                    nombre: '',
                    codigo: '',
                },
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.marca !== this.props.marca) {
            this.setState({
                marca: this.props.marca.marca,
            });
        }
    }

    handleOnChange = (e) => {
        this.setState({
            marca: {
                ...this.state.marca,
                [e.target.name]: e.target.value,
            }
        });
    }

    handleOnSave = () => {
        const { nombre, idMarca } = this.state.marca;

        if (nombre) {
            this.props.sagaSaveMarca({ 
                ...this.state.marca,
                idMarca: idMarca,
                idInstalacion: this.props.instalacion.id,
                codigo: nombre.toUpperCase().replace(/ /g, '_'),
            }).then(() => {
                this.props.history.push('/Marcas/');
            }).catch((error) => {
                Notification.showError('Error al guardar la marca', error);
            });
        } else {
            Notification.showError('El nombre es obligatorio')
        }
    }

    render() {
        return (
            <MarcaEdit
                entidad="Marca"
                marca={this.state.marca}
                handleOnChange={this.handleOnChange}
                handleOnSave={this.handleOnSave}
                handleOnCancel={() => this.props.history.push('/Marcas/')}
                error={this.state.error}
            />
        );
    }
}

MarcaEditContainer.propTypes = {
    marca: PropTypes.object,
    usuario: PropTypes.object,
    instalacion: PropTypes.object,
    sagaSaveMarca: PropTypes.func.isRequired,
    sagaGetMarca: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    marca: marcasEditSelector(state),
    usuario: usuarioSelector(state),
    instalacion: instalacionSelector(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    sagaGetMarca, sagaSaveMarca 
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MarcaEditContainer);
